import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { string, func, elementType, bool } from 'prop-types';

import { checkoutFormTypes } from '~screens/Dashboard/screens/Home/screens/Checkout/propTypes';
import Checkbox from '~components/Checkbox';

import styles from './styles.module.scss';

const Snackbar = ({
  borderAdornementPosition,
  classNames,
  labelClassName,
  icon,
  inputName,
  textDisclaimer,
  onChange,
  textComponent: TextComponent,
  error,
  startsInFalse,
  borderless,
  errors,
  setTouched,
  hide
}) => {
  const [disclaimerChecked, setDisclaimerChecked] = useState(!startsInFalse);
  const handleCheckDisclaimer = e => {
    setDisclaimerChecked(!!e.target.checked);
    onChange && onChange(!!e.target.checked);
  };
  useEffect(() => {
    if (setTouched) {
      setTouched({
        [inputName]: true
      });
    }
    if (onChange) {
      onChange(!startsInFalse);
    }
  }, []);

  return (
    <>
      {!hide && (
        <div
          className={cn(classNames, styles.disclaimerContainer, {
            [styles.borderless]: borderless,
            [styles[`border-${borderAdornementPosition}`]]: borderAdornementPosition
          })}>
          {icon && <img className="m-right-2" src={icon} alt={inputName} />}
          {onChange ? (
            <Checkbox
              name={inputName}
              label={textDisclaimer || <TextComponent />}
              className={cn('full-width-mobile', styles.checkbox, { 'm-bottom-4': errors?.[inputName] })}
              isChecked={disclaimerChecked}
              onChange={handleCheckDisclaimer}
              error={errors?.[inputName] || error}
              showError={!!errors?.[inputName] || !!error}
              labelClassName={labelClassName}
            />
          ) : (
            <>
              {textDisclaimer && <p>{textDisclaimer}</p>}
              {TextComponent && <TextComponent />}
            </>
          )}
        </div>
      )}
    </>
  );
};

Snackbar.defaultProps = {
  borderAdornementPosition: 'left',
  borderless: false,
  hide: false,
  inputName: '',
  startsInFalse: false,
  textDisclaimer: ''
};

Snackbar.propTypes = {
  borderAdornementPosition: string,
  borderless: bool,
  classNames: string,
  error: string,
  errors: checkoutFormTypes,
  hide: bool,
  icon: string,
  inputName: string,
  labelClassName: string,
  setTouched: func,
  startsInFalse: bool,
  textComponent: elementType,
  textDisclaimer: string,
  onChange: func
};

export default Snackbar;
